'use strict';

import dateInputPolyfill from 'date-input-polyfill';
import angularPlugin from './raven-angular';
import angular from 'angular';
import 'angular-google-analytics';

import TorchmarkModule from './torchmark';
import './app.scss';


let dependencies = [ TorchmarkModule, 'angular-google-analytics' ];

if (window.jangl && window.jangl.sentryUrl) {
    var Raven = require('raven-js');
    var version = window.jangl.version || '0';

    Raven
        .config(window.jangl.sentryUrl, {release: version})
        .install();
    angularPlugin(Raven, angular);

    dependencies.push(angularPlugin.moduleName);
}

var app = angular.module('jangl-capture-forms', dependencies);

if (window.jangl.googleAnalyticsID) {
    let tracker = window.jangl.googleAnalyticsID;

    app.config(['AnalyticsProvider', function (AnalyticsProvider) {

        // suppress GA if we're not on the live site
        if( window.location.hostname.toLowerCase().includes('localhost') ){
            AnalyticsProvider.enterTestMode();
        }

        AnalyticsProvider.setAccount(tracker);
        AnalyticsProvider.trackPages(true);
        AnalyticsProvider.trackUrlParams(true);
        AnalyticsProvider.useEnhancedLinkAttribution(true);
    }]).run(['Analytics', function(Analytics) {}]);
}



// WEBPACK FOOTER //
// ./app/app.js